import { createSelector } from 'reselect';
import { IAppState } from '../../../../../AppModulesWrapper';
import { selectPackages } from './selectPackages';

export const selectActivePackage = createSelector(
  (state: IAppState) => selectPackages(state),
  packages => packages.find(({ selected }) => selected) ?? null,
);
